import React, { useEffect } from 'react';
import { ANIMATION_TRIGGER } from 'common/constants';
import { scrollIntoViewById } from 'client/components/common/BuildingBlocks/utils/common';

const ScrollToElement: React.FC<{ id?: string }> = ({ id }) => {
	useEffect(() => {
		const handler = () => scrollIntoViewById(id, { hash: true });
		window.addEventListener(ANIMATION_TRIGGER.ON_CARD_EXPOSE_COMPLETE, handler);
		return () => {
			window.removeEventListener(ANIMATION_TRIGGER.ON_CARD_EXPOSE_COMPLETE, handler);
		};
	}, [id]);
	return null;
};

export default ScrollToElement;
